import React from 'react'
import { withStyles } from 'material-ui/styles'
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from 'material-ui/Table'
import Button from 'material-ui/Button'
import AddIcon from 'material-ui-icons/Add'
import './locations.css'

const styles = theme => ({
  root: {
    width: '100%',
    overflowX: 'auto'
  },
  table: {
    minWidth: 200
  }
})

const LocationsList = props => {
  const { locations, classes, handleEditBtn, handleNewLocation } = props

  return (
    <div className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Contact</TableCell>
            <TableCell>Phone</TableCell>
            <TableCell>Street</TableCell>
            <TableCell>City</TableCell>
            <TableCell>Pick Up</TableCell>
            <TableCell>Latitude</TableCell>
            <TableCell>Longitude</TableCell>
            <TableCell />
          </TableRow>
        </TableHead>
        <TableBody>
          {locations.map(location => {
            return (
              <TableRow key={location._id}>
                <TableCell>{location.name}</TableCell>
                <TableCell>{location.contactName}</TableCell>
                <TableCell>{location.contactPhone}</TableCell>
                <TableCell>{location.street}</TableCell>
                <TableCell>{location.city}</TableCell>
                <TableCell>{location.pickup ? 'Yes' : 'No'}</TableCell>
                <TableCell>{location.latitude}</TableCell>
                <TableCell>{location.longitude}</TableCell>
                <TableCell>
                  <Button
                    color='primary'
                    onClick={() => handleEditBtn(location)}
                    variant='raised'
                    className={classes.button}
                    aria-label='Edit Location'
                  >
                    Edit
                  </Button>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
      <Button
        id='new-location'
        variant='fab'
        color='primary'
        onClick={handleNewLocation}
      >
        <AddIcon />
      </Button>
    </div>
  )
}

export default withStyles(styles)(LocationsList)



// WEBPACK FOOTER //
// ./src/locations/Locations.js